import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ActionDiffer from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVersionDiffWorkflow/StepConfigAction/ActionDiffer';
import ParallelDiffer from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVersionDiffWorkflow/StepConfigParallel/ParallelDiffer';
import WaitDiffer from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVersionDiffWorkflow/StepConfigWait/WaitDiffer';
import { WorkflowVersionStepDiff } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { Trigger } from 'dashboard/models/trigger';
import { WorkflowActionMeta } from 'dashboard/models/workflow';
import { GenericWorkflowAction } from 'dashboard/models/workflow-schema';
import {
  WorkflowActionFromConfig,
  WorkflowStep,
  WorkflowStepType,
} from 'dashboard/models/workflow-version';
import { Paragraph } from 'design-system/components/Text';

const WorkflowStepDiffPanelPropertiesContainer = styled.div`
  padding: 0 ${Spacing[4]};
`;

const StyledParagraph = styled(Paragraph)`
  margin: ${Spacing[2]};
`;

const renderWorkflowStepDiffPanelProperties = ({
  workflowVersionId,
  workflowStep,
  workflowStepDiff,
  stepsConfig,
  trigger,
  workflowActionsByKey,
  actionMeta,
}: WorkflowStepDiffPanelPropertiesProps) => {
  switch (workflowStep.type) {
    case WorkflowStepType.Action:
      if (workflowStep.action != null && workflowActionsByKey[workflowStep.action.key]) {
        return (
          <ActionDiffer
            workflowVersionId={workflowVersionId}
            workflowStepDiff={workflowStepDiff}
            step={workflowStep}
            actionParameters={workflowStep.action.params as WorkflowActionFromConfig['params']}
            workflowAction={workflowActionsByKey[workflowStep.action.key]}
            actionMeta={actionMeta}
          />
        );
      } else {
        return <StyledParagraph>Property Diff Preview not supported</StyledParagraph>;
      }
    case WorkflowStepType.Parallel:
      return <ParallelDiffer workflowStepDiff={workflowStepDiff} step={workflowStep} />;
    case WorkflowStepType.Wait:
      return (
        <WaitDiffer
          workflowStepDiff={workflowStepDiff}
          step={workflowStep}
          stepsConfig={stepsConfig}
          trigger={trigger}
        />
      );
    default:
      return <StyledParagraph>No Workflow Step Properties</StyledParagraph>;
  }
};

interface WorkflowStepDiffPanelPropertiesProps {
  workflowVersionId: string;
  workflowStep: WorkflowStep;
  workflowStepDiff?: WorkflowVersionStepDiff;
  stepsConfig: WorkflowStep[];
  trigger: Trigger;
  workflowActionsByKey: Record<GenericWorkflowAction['key'], GenericWorkflowAction>;
  actionMeta: WorkflowActionMeta;
}

const WorkflowStepDiffPanelProperties = ({
  workflowVersionId,
  workflowStep,
  workflowStepDiff,
  stepsConfig,
  trigger,
  workflowActionsByKey,
  actionMeta,
}: WorkflowStepDiffPanelPropertiesProps) => {
  return (
    <WorkflowStepDiffPanelPropertiesContainer>
      {renderWorkflowStepDiffPanelProperties({
        workflowVersionId,
        workflowStep,
        workflowStepDiff,
        stepsConfig,
        trigger,
        workflowActionsByKey,
        actionMeta,
      })}
    </WorkflowStepDiffPanelPropertiesContainer>
  );
};

export default WorkflowStepDiffPanelProperties;
